import React from "react";

export const Pies2 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <g>
      <rect width={44} height={28} rx={1} fill="#F1F2F6" />
      <path
        fill="#DFA543"
        d="M27.8,24.5l-2.7-4.8c-0.8,0.4-1.7,0.7-2.6,0.7V26C24.3,25.9,26.2,25.4,27.8,24.5z"
      />
      <path
        fill="#3A5998"
        d="M28.4,14.3c-0.1,2-1.1,3.9-2.8,5.1l2.8,4.8c3.5-2.1,5.6-5.8,5.7-9.9H28.4z"
      />
      <path
        fill="#07C082"
        d="M21.8,26v-5.6c-3.5-0.1-6.1-3.1-6-6.6c0.1-3.3,2.7-5.9,6-6.1V2C15.3,2,10,7.4,10,14S15.3,26,21.8,26z"
      />
      <path
        fill="#55ACEE"
        d="M22.5,7.8c3.2,0.2,5.8,2.8,5.9,6H34C33.8,7.4,28.8,2.3,22.5,2.1V7.8z"
      />
    </g>

    <g>
      <rect width={44} height={28} rx={1} fill="#F1F2F6" x={48} />
      <path
        fill="#6441A5"
        d="M59.5,19.7l4.9-2.8c-0.4-0.8-0.7-1.7-0.7-2.6H58C58.1,16.2,58.6,18,59.5,19.7z"
      />
      <path
        fill="#3A5998"
        d="M69.7,20.3c-2-0.1-3.9-1.2-5.1-2.9l-4.8,2.8c2.1,3.5,5.8,5.7,9.9,5.8C69.7,26,69.7,20.3,69.7,20.3z"
      />
      <path
        fill="#55ACEE"
        d="M76.3,14.3c-0.2,3.2-2.7,5.8-6,6V26c6.4-0.2,11.5-5.3,11.7-11.7H76.3z"
      />
      <path
        fill="#FF6500"
        d="M63.8,13.7c0.2-3.2,2.7-5.8,6-6V2c-6.4,0.2-11.5,5.3-11.7,11.7H63.8z"
      />
      <path
        fill="#DFA543"
        d="M70.3,7.8c3.2,0.2,5.8,2.7,6,6H82C81.8,7.4,76.7,2.3,70.3,2.1V7.8z"
      />
    </g>
  </g>
);
